export const updatePageState = states => {
    const newState = window.history.state || {}
    Object.keys(states).map(key => (newState[key] = states[key]))
    window.history.replaceState(newState, '')
  }
